import { Entity, MicroMClient } from "@mcurros2/microm";
import { ProductosIcon } from "../../Productos/Productos";
import { ClientesTiendasProductosDef } from "./ClientesTiendasProductosDef";

export class ClientesTiendasProductos extends Entity<ClientesTiendasProductosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new ClientesTiendasProductosDef(), parentKeys);
        this.Form = import('./ClientesTiendasProductosForm').then((module) => module.ClientesTiendasProductosForm);
        this.Title = "Productos";
        this.Icon = ProductosIcon;
        this.HelpText = "* Aquí puede asignar los productos para la tienda.";
    }
}   